// RatingWidget.jsx

import React, { useState } from 'react';
import '../index.css';

const StarComponent = ({ category, rating }) => {
  const [actualRating, setRating] = useState(rating || 0);

  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
  };

  if (`${category}` != 'undefined') {
    return (
      <div className="category-widget" style={{marginTop: '5px'}}>
        <p>{`${category}`}</p>
        <div>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`star ${star <= actualRating ? 'selected' : ''}`}
              // onClick={() => handleStarClick(star)}
            >
              &#9733; 
            </span>
          ))}
        </div>
        <p style={{color:'gray', fontSize:'15px'}}>({actualRating}/5 stars)</p>
      </div>
    );
  } else {
    return (
      <div className="category-widget" style={{marginBottom: '5px'}}>
        <div className='row-container'>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`star ${star <= actualRating ? 'selected' : ''}`}
              // onClick={() => handleStarClick(star)}
            >
              &#9733; 
            </span>
          ))}
        </div>
        <p style={{color:'gray', fontSize:'15px'}}>({actualRating}/5 stars)</p>
      </div>
    )
  }
};

export default StarComponent;
